// extracted by mini-css-extract-plugin
export default {"container":"sR-z","darkBackground":"tR-z","whiteBackground":"uR-z","headerButton":"vR-z","calloutHeading":"wR-z","calloutSubHeading":"xR-z"};